import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Los Angeles">
                <h1>
                  Custom Software Development Company <span>Los Angeles</span>
                </h1>
              </div>
              <p className="main_para">
                As a growth-oriented software development company Los Angeles,
                our skilled software developers employ modern frameworks and
                technologies to deliver feature-rich & adaptable software
                solutions. We provide a distinctive advantage to your business's
                IT portfolio with our top-tier software development services,
                like data entry, workflow management, employee dashboards,
                customer portals, data access controls, reports & more
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
